/* @jsx h */
import { defineComponent, h, type PropType } from "vue";
import type { GridColumnDef, CommitDir } from "./types";
import { TextEditor } from "./TextEditor";
import { NumberEditor } from "./NumberEditor";
import { SelectEditor } from "./SelectEditor";
import { BooleanEditor } from "./BooleanEditor";
import { ColorEditor } from "./ColorEditor";

export const CellEditor = defineComponent({
  name: "CellEditor",
  props: {
    column: { type: Object as PropType<GridColumnDef>, required: true },
    value: { type: null as any, default: null },
    initialChar: { type: String as PropType<string | null>, default: null },
    onCommit: {
      type: Function as PropType<(value: any, dir: CommitDir) => void>,
      required: true,
    },
    onCancel: { type: Function as PropType<() => void>, required: true },
  },
  setup(props) {
    return () => {
      const shared = {
        column: props.column,
        value: props.value,
        initialChar: props.initialChar,
        onCommit: props.onCommit,
        onCancel: props.onCancel,
      };

      switch (props.column.type) {
        case "select":
          return <SelectEditor {...shared} />;
        case "number":
        case "price":
          return <NumberEditor {...shared} />;
        case "boolean":
          return <BooleanEditor {...shared} />;
        case "color":
          return <ColorEditor {...shared} />;
        default:
          return <TextEditor {...shared} />;
      }
    };
  },
});
